module.exports = __webpack_public_path__ + "img/worldmap-640.740c8d69.png";